import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSwipeable } from "react-swipeable";

const slides = [
  {
    image: "/assets/getting-started/1.png",
    title: "Personalised recipes at your fingertips",
    text: "Tell us what you're craving or snap a photo of what's in your fridge, and we'll do the rest.",
  },
  {
    image: "/assets/getting-started/2.png",
    title: "Meal planning, but with super powers",
    text: "Add recipes to the calendar and we can let you know what ingredients you need for the week, keep the recipes easy to find and even help you fill recipes between days.",
  },
  {
    image: "/assets/getting-started/3.png",
    title: "Edits, changes, scaling ... it's easy, we're flexible",
    text: "Not happy with the recipe? keep chatting with Sous and we'll rework it until it's perfect. Need to scale it up or down? Easy, we'll handle that too.",
  },
  {
    image: "/assets/getting-started/4.png",
    title: "Nostalgic for something you've had before?",
    text: "All your recipes, favourites and psat conversations are available from the menu.",
  },
  {
    image: "/assets/getting-started/5.png",
    title: "Hosting made simple (the recipes at least)",
    text: "Add recipes to a mealplan to keep them together, get a single shopping list and work easily through multiple recipe instructions from one place.",
  },
];

export default function Showcase({ token }) {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  const handleNext = () => {
    if (index < slides.length - 1) {
      setIndex(index + 1);
    } else {
      navigate("/"); // go to home, don't push subscription yet.
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: () => setIndex((prev) => Math.max(prev - 1, 0)),
    trackMouse: true,
  });

  return (
    <div
      {...swipeHandlers}
      className="flex flex-col justify-between h-full min-h-[calc(100vh-120px)] px-4 pt-6 pb-4 text-center"
    >
      {/* Title */}
      <h2 className="text-xl font-semibold text-charcoal">{slides[index].title}</h2>

      {/* Main Content */}
      <div className="flex-1 flex flex-col justify-center items-center space-y-4">
        <img
          src={slides[index].image}
          alt={slides[index].title}
          className="w-48 max-w-full rounded-lg"
        />
        <p className="text-sm text-slate-700">{slides[index].text}</p>

        {/* Progress Dots */}
        <div className="flex space-x-2 mt-2">
          {slides.map((_, i) => (
            <div
              key={i}
              className={`h-2 w-2 rounded-full transition ${
                i === index ? "bg-sage" : "bg-charcoal"
              }`}
            ></div>
          ))}
        </div>
      </div>

      {/* Buttons */}
      <div className="space-y-3 mt-4">
        <button
          onClick={handleNext}
          className={`w-full text-white text-sm px-4 py-2 rounded transition ${
            index < slides.length - 1
              ? "bg-sage hover:bg-sage/80"
              : "bg-charcoal hover:bg-slate-800"
          }`}
        >
          {index < slides.length - 1 ? "Next" : "Get Started"}
        </button>
        <button
          onClick={() => navigate("/")} // changed from /subscribe to go to home
          className="text-sm text-charcoal underline"
        >
          Skip
        </button>
      </div>
    </div>
  );
}
